import dayjs from 'dayjs'
import 'dayjs/locale/id'

dayjs.locale('id')

export const dateLong = (date: string | Date) => dayjs(date).format('D MMMM YYYY')

export const dateTimeLong = (date: string | Date) => dayjs(date).format('D MMMM YYYY HH:mm:ss')
